<!--
 * @Author: your name
 * @Date: 2021-09-17 14:31:54
 * @LastEditTime: 2025-07-23 19:41:50
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\login\Register.vue
-->
<template>
  <div class="register">
    <div class="title flex-c-c">{{ $t('system.editPwd') }}</div>
    <div class="user-form">

      <div style="margin-left: 30px;line-height: 24px;color: #F56C6C; text-indent: 2em;">
        {{ $t('nlR07') }}
      </div>
      <el-form :model="user" :rules="rules" ref="userForm" label-width="200px">
        <el-form-item :label="$t('nlR06')" prop="oldPassword">
          <el-input v-model="user.oldPassword" type="password" show-password auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clrp9')" prop="newPassword">
          <el-input v-model="user.newPassword" @input="changePassword" type="password" show-password
            auto-complete="new-password"></el-input>
          <div style="margin-left: 24px;">
            <el-progress :percentage="strength" :status="strengthStatus"></el-progress>
          </div>
        </el-form-item>
        <el-form-item :label="$t('clr10')" prop="rpassword">
          <el-input v-model="user.rpassword" type="password" show-password autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label-width="50px">
          <el-button type="primary" @click="submitForm('userForm')" round>{{ $t('csr7') }}</el-button>
        </el-form-item>
        <el-form-item label-width="30px">
          <div @click="setShowType" class="re-login">
            <span>{{ $t('nlR05') }}?</span>&nbsp;
            <span style="color: #606266;">{{ $t('clr14') }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// admin/signin/isLegal
// admin/signin/getEmailCode
import passwordStrength from '@/assets/scripts/passwordStrength.js'
export default {
  name: "Register",
  props: {
    title: {
      type: String,
      default: "标 题"
    }
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr15')));
      } else if (value !== this.user.newPassword) {
        this.user.rpassword = "";
        callback(new Error(this.$t('clr16')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('nlR01')));
      } else if (passwordStrength(value).strength < 3) {
        callback(new Error(this.$t('nlR02')))
      } else {
        callback();
      }
    };
    return {
      codeTime: 0,
      intervalTime: null,
      error: {
        email: "",
        user_name: "",
        referral_code: "",
        email_code: true
      },
      user: {
        oldPassword: "",
        newPassword: "",
        rpassword: "",
      },
      rules: {
        oldPassword: [{ required: true, message: '请填写旧密码', trigger: 'blur' }],
        newPassword: [{ validator: passStrength, trigger: 'blur' }],
        rpassword: [{ validator: validatePass, trigger: 'blur' }],
      },
      strength: 0,
      strengthStatus: 'exception',//exception/warning/success
    }
  },
  methods: {
    setShowType() {
      this.$emit("setShowType");
    },
    changePassword(val) {
      console.log(val);
      const { strength } = passwordStrength(val);
      this.strengthStatus = ['exception', 'exception', 'warning', 'success', 'success', 'success'][strength]
      this.strength = (strength * 20) || 10;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { oldPassword, newPassword, rpassword } = this.user;
          console.log(oldPassword, newPassword, rpassword);
          this.$http.post('/admin/access/editMyself', {
            id: this.$cookies.get('user_id'),
            pwd_update: 1,
            pwd_original: oldPassword,
            pwd_new1: newPassword,
            pwd_new2: rpassword
          }, (data) => {
            if (data.length == 0) {
              this.$msg({ type: 'success', message: this.$t('system.changePwdSucc') });
              this.$cookies.keys().forEach(key => {
                key !== 'rtp' && this.$cookies.remove(key);
              })
              this.$router.go(0);
            } else {
              this.$msg({ type: 'warning', message: data.tips });
              this.$refs[formName].resetFields();
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.register {
  background-color: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;

  .title {
    height: 50px;
    font-size: 20px;
    color: #fff;
    // background-image: linear-gradient(270deg,
    //     #86eae7 0%,
    //     #4cccf0 45%,
    //     #11adf8 100%),
    //   linear-gradient(#ffffff, #ffffff);
    // background-blend-mode: normal, normal;
    background-color: var(--theme-color-customized-1);
  }

  .user-form {
    padding-right: 30px;
    padding-top: 20px;
    background-color: #fff;

    .el-form-item+.el-form-item {
      margin-top: 20px;
    }

    /deep/ .el-input-group__append {
      border-radius: 0px 20px 20px 0px;
      padding: 0 6px;
      text-align: center;
      width: 100px;
    }

    .re-login {
      text-align: center;
      line-height: 10px;
      cursor: pointer;
    }

    .email-code {
      cursor: not-allowed;
    }

    .email-code-hover {
      cursor: pointer;
    }
  }
}
</style>